module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.curInput[_vm.fieldName],
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "关联关系数据表",
      "prop": "form_model"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput[_vm.fieldName].form_model),
      expression: "curInput[fieldName].form_model"
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "placeholder": "请选择数据表"
    },
    domProps: {
      "value": (_vm.curInput[_vm.fieldName].form_model)
    },
    on: {
      "input": function($event) {
        _vm.curInput[_vm.fieldName].form_model = $event
      }
    }
  }, _vm._l((_vm.formList), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.title + '(' + item.name + ')',
        "value": item.id
      }
    })
  })), _vm._v(" "), (_vm.selectKey) ? _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput[_vm.fieldName].form_key_field),
      expression: "curInput[fieldName].form_key_field"
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "placeholder": "请选择关联的外键"
    },
    domProps: {
      "value": (_vm.curInput[_vm.fieldName].form_key_field)
    },
    on: {
      "input": function($event) {
        _vm.curInput[_vm.fieldName].form_key_field = $event
      }
    }
  }, _vm._l((_vm.foreignFields), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.name + '(' + item.title + ')',
        "value": item.field_id
      }
    })
  })) : _vm._e()]), _vm._v(" "), _c('filter-config', {
    attrs: {
      "filter": _vm.curInput[_vm.fieldName].filter,
      "fields": _vm.fieldList,
      "rules": _vm.rules
    }
  }), _vm._v(" "), _c('search-config', {
    attrs: {
      "search": _vm.curInput[_vm.fieldName].search,
      "fields": _vm.fieldList,
      "rules": _vm.rules
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分页设置",
      "prop": "page_size"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput[_vm.fieldName].page_size),
      expression: "curInput[fieldName].page_size"
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.curInput[_vm.fieldName].page_size)
    },
    on: {
      "input": function($event) {
        _vm.curInput[_vm.fieldName].page_size = _vm._n($event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "弹窗大小"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.curInput[_vm.fieldName].size),
            expression: "curInput[fieldName].size"
          }],
          attrs: {
            "clearable": "",
            "placeholder": "默认large"
          },
          domProps: {
            "value": (_vm.curInput[_vm.fieldName].size)
          },
          on: {
            "input": function($event) {
              _vm.curInput[_vm.fieldName].size = $event
            }
          }
        }, _vm._l((_vm.windowSizes), function(item) {
          return _c('el-option', {
            attrs: {
              "label": item,
              "value": item
            }
          })
        }))]
      }
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择数量",
      "prop": "select_type"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput[_vm.fieldName].select_type),
      expression: "curInput[fieldName].select_type"
    }],
    domProps: {
      "value": (_vm.curInput[_vm.fieldName].select_type)
    },
    on: {
      "input": function($event) {
        _vm.curInput[_vm.fieldName].select_type = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 10
    }
  }, [_vm._v("单选")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 20
    }
  }, [_vm._v("多选")])])]), _vm._v(" "), (_vm.curInput[_vm.fieldName].select_type === 20) ? _c('el-form-item', {
    attrs: {
      "label": "最小选择数量",
      "prop": "min_select_num"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput[_vm.fieldName].min_select_num),
      expression: "curInput[fieldName].min_select_num"
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "type": "number",
      "placeholder": "0表示不限制"
    },
    domProps: {
      "value": (_vm.curInput[_vm.fieldName].min_select_num)
    },
    on: {
      "input": function($event) {
        _vm.curInput[_vm.fieldName].min_select_num = _vm._n($event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.curInput[_vm.fieldName].select_type === 20) ? _c('el-form-item', {
    attrs: {
      "label": "最大选择数量",
      "prop": "max_select_num"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput[_vm.fieldName].max_select_num),
      expression: "curInput[fieldName].max_select_num"
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "type": "number",
      "placeholder": "0表示不限制"
    },
    domProps: {
      "value": (_vm.curInput[_vm.fieldName].max_select_num)
    },
    on: {
      "input": function($event) {
        _vm.curInput[_vm.fieldName].max_select_num = _vm._n($event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "显示字段",
      "prop": "display_fields"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.curInput[_vm.fieldName].display_fields),
            expression: "curInput[fieldName].display_fields"
          }],
          attrs: {
            "clearable": "",
            "multiple": ""
          },
          domProps: {
            "value": (_vm.curInput[_vm.fieldName].display_fields)
          },
          on: {
            "input": function($event) {
              _vm.curInput[_vm.fieldName].display_fields = $event
            }
          }
        }, _vm._l((_vm.fieldList), function(item) {
          return _c('el-option', {
            attrs: {
              "label": item.name + '(' + item.title + ')',
              "value": item.field_id
            }
          })
        }))]
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c1e93308!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model/configComponents/relationConfig.vue
// module id = 1983
// module chunks = 2